// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3lTzj","info":"UpdateTermsInfo_info__2U29p"};